"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-six/sections/teamSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type TeamSection366sItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/team/team-img-one.png" | "/Templates/Doccure/img/team/team-img-two.png" | "/Templates/Doccure/img/team/team-img-three.png" | "/Templates/Doccure/img/team/team-img-four.png" */
    src: string;
    /** Detected variants: "Dr. Brenda Ramsey" | "Dr. John Smith" | "Dr. Karen Perez" | "Dr. Steven Johnson" */
    link0Text: ReactNode;
    /** Detected variants: "Veterinary Surgeon" | "Veterinary Neurologist" | "Veterinary Dermatologist" | "Veterinary Nutritionist" */
    p0Text: ReactNode;
    /** Detected variants: "col-xl-3 col-md-6 col-sm-6" */
    className?: string;
    /** Detected variants: "team-item-six" */
    div0ClassName?: string;
    /** Detected variants: "team-overly-img" */
    div0ClassName2?: string;
    /** Detected variants: "team" */
    alt?: string;
    /** Detected variants: "img-fluid img-two" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "team" */
    imageWithBasePath1Alt?: string;
    /** Detected variants: "img-fluid img-three" */
    imageWithBasePath1ClassName?: string;
    /** Detected variants: "/Templates/Doccure/img/icons/team-icon.svg" */
    imageWithBasePath1Src?: string;
    /** Detected variants: "team-content" */
    div1ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "#" */
    href?: string;
};
export type HomeSixTeamSectionGeneratedProps = {
    divDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TeamSection366sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div0ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TeamSection366sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: TeamSection366sItem) => Partial<ComponentProps<"h3">>);
    divDiv0Div1H30Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: TeamSection366sItem) => Partial<ComponentProps<typeof SmartLink>>);
    /** Default: "Teams" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "Meet Our" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    /** Default: "Veterinarians" */
    sectionDiv0Div0H20H2Text2?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Expert" */
    sectionDiv0Div0H20Span0SpanText?: ReactNode;
    sectionDiv0Div1ClassName?: string;
    /** Default: "foot-prints" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/foot-prints-1.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    teamSection366s: TeamSection366sItem[];
    teamSection366sItemWrapper?: (item: TeamSection366sItem, content: ReactNode) => ReactNode;
    teamSection366sRenderer?: (defaultNode: ReactNode) => ReactNode;
    teamSection366sLinkVisible?: boolean;
    teamSection366sLinkRenderer?: (item: TeamSection366sItem, defaultNode: ReactNode) => ReactNode;
    teamSection366sImageVisible?: boolean;
    teamSection366sImageRenderer?: (item: TeamSection366sItem, defaultNode: ReactNode) => ReactNode;
    teamSection366sH3Visible?: boolean;
    teamSection366sH3Renderer?: (item: TeamSection366sItem, defaultNode: ReactNode) => ReactNode;
    teamSection366sLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: TeamSection366sItem) => Partial<ComponentProps<typeof SmartLink>>);
    teamSection366sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TeamSection366sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    teamSection366sH3Props?: Partial<ComponentProps<"h3">> | ((item: TeamSection366sItem) => Partial<ComponentProps<"h3">>);
};

const HomeSixTeamSectionGenerated: FC<HomeSixTeamSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "Teams",
    sectionDiv0Div0H20H2Text = "Meet Our",
    sectionDiv0Div0H20H2Text2 = "Veterinarians",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0H20Span0SpanText = "Expert",
    sectionImageWithBasePath0ImageAlt = "foot-prints",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/foot-prints-1.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    divDiv0Div0ImageWithBasePath0ImageProps,
    divDiv0Div0ImageWithBasePath1ImageProps,
    divDiv0Div1H30H3Props,
    divDiv0Div1H30Link0LinkProps,
    sectionDiv0Div1ClassName,
    teamSection366s,
    teamSection366sItemWrapper,
    teamSection366sRenderer,
    teamSection366sLinkVisible,
    teamSection366sLinkRenderer,
    teamSection366sImageVisible,
    teamSection366sImageRenderer,
    teamSection366sH3Visible,
    teamSection366sH3Renderer,
    teamSection366sLinkProps,
    teamSection366sImageProps,
    teamSection366sH3Props,
}) => {
    return (
        <section className="team-section-six section">
            <div className="container">
                <div className="section-header-six text-center">
                    <div className="section-sub-title">{sectionDiv0Div0Div0DivText}</div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>
                            {sectionDiv0Div0H20H2Text}
                            <span className="line-6">{sectionDiv0Div0H20Span0SpanText}</span>
                            {sectionDiv0Div0H20H2Text2}
                        </h2>
                    ))}
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row g-5"}>
                    {renderCollectionNode(
                        teamSection366s,
                        (item: TeamSection366sItem) => (
                            <div className={item.className ?? "col-xl-3 col-md-6 col-sm-6"} key={item.key}>
                                <div className={item.div0ClassName ?? "team-item-six"}>
                                    <div className={item.div0ClassName2 ?? "team-overly-img"}>
                                        {renderItemNode(teamSection366sImageVisible, teamSection366sImageRenderer, item, (
                                            <SmartImage src={item.src} alt={item.alt ?? "team"} className={item.imageWithBasePath0ClassName ?? "img-fluid img-two"} {...(typeof teamSection366sImageProps === "function" ? teamSection366sImageProps(item) : (teamSection366sImageProps ?? {}))} {...(typeof divDiv0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                        ))}
                                        {renderItemNode(teamSection366sImageVisible, teamSection366sImageRenderer, item, (
                                            <SmartImage src={item.imageWithBasePath1Src ?? "/Templates/Doccure/img/icons/team-icon.svg"} alt={item.imageWithBasePath1Alt ?? "team"} className={item.imageWithBasePath1ClassName ?? "img-fluid img-three"} {...(typeof teamSection366sImageProps === "function" ? teamSection366sImageProps(item) : (teamSection366sImageProps ?? {}))} {...(typeof divDiv0Div0ImageWithBasePath1ImageProps === "function" ? divDiv0Div0ImageWithBasePath1ImageProps(item) : (divDiv0Div0ImageWithBasePath1ImageProps ?? {}))} />
                                        ))}
                                    </div>
                                    <div className={item.div1ClassName ?? "team-content"}>
                                        {renderItemNode(teamSection366sH3Visible, teamSection366sH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof teamSection366sH3Props === "function" ? teamSection366sH3Props(item) : (teamSection366sH3Props ?? {}))} {...(typeof divDiv0Div1H30H3Props === "function" ? divDiv0Div1H30H3Props(item) : (divDiv0Div1H30H3Props ?? {}))}>
                                                {renderItemNode(teamSection366sLinkVisible, teamSection366sLinkRenderer, item, (
                                                    <SmartLink href={item.href ?? "#"} {...(typeof teamSection366sLinkProps === "function" ? teamSection366sLinkProps(item) : (teamSection366sLinkProps ?? {}))} {...(typeof divDiv0Div1H30Link0LinkProps === "function" ? divDiv0Div1H30Link0LinkProps(item) : (divDiv0Div1H30Link0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                ))}
                                            </h3>
                                        ))}
                                        <p>{item.p0Text}</p>
                                    </div>
                                </div>
                            </div>
                        ),
                        teamSection366sItemWrapper,
                        teamSection366sRenderer
                    )}
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid element-one" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeSixTeamSectionGenerated;
